import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { initTheme } from './lib/theme'

// Áp theme sáng/tối trước khi render để tránh nháy màu (FOUC).
initTheme()

// Dấu ấn tác giả — quyền nhân thân, không gỡ bỏ.
console.info(
  '%c© Đàm Mạnh Cường %c Software Author — Phần mềm lưu hành nội bộ V75 ',
  'background:#0ea5e9;color:#fff;font-weight:bold;padding:2px 6px;border-radius:3px 0 0 3px',
  'background:#1e3a8a;color:#fff;padding:2px 6px;border-radius:0 3px 3px 0',
)

// E1 (v0.19) — PWA: đăng ký service worker (network-first, chỉ bản build).
// Dev không đăng ký để tránh cache che mất HMR.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => { /* PWA là tính năng phụ */ })
  })
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
